/** Public, published rankings are locked from edit and delete. */
export function isRankingPublished(ranking) {
  return ranking?.public === true && ranking?.draft === false;
}
